import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { localeSelector } from 'viewModel/selectors/locale/localeSelector';
import LanguageLocale from 'utils/LanguageLocale';
import ModifySubscriptionErrorModalEN from 'components/GlobalModals/ModifySubscriptionErrorModal/locales/ModifySubscriptionErrorModal_en_US';
import ModifySubscriptionErrorModalFR from 'components/GlobalModals/ModifySubscriptionErrorModal/locales/ModifySubscriptionErrorModal_fr_CA';

const getText = LanguageLocale.getLocalisedDataFromResource(ModifySubscriptionErrorModalEN, ModifySubscriptionErrorModalFR);

const withModifySubscriptionErrorModalProps = connect(
    createSelector(localeSelector, () => {
        const modifySubscription = getText('modifySubscription');
        const errorMessage = getText('errorMessage');
        const done = getText('done');

        return {
            modifySubscription,
            errorMessage,
            done
        };
    })
);

export { withModifySubscriptionErrorModalProps };
